
import { ApiAccess } from "../apiclient/ApiClient";
import AppMenuItemData from "./AppMenuItemData";
import { MessageManager, MessageProvider } from "./AppMessages";

export default class AppContext {
    //private tenantId:string;
    //private channel:string;
    private merchantAppId: string;
    private appId: string;
    private messageManager: MessageManager;
    private leavingExtraMarginBottom = false;
    private apiAccess: ApiAccess;
    private externalMenuItems: AppMenuItemData[] = [];
    private showAsShakeForNewFeatureTab: boolean;

    constructor(
        appId: string, merchantAppId: string, lang: string = "en", 
        externalMenuItems: AppMenuItemData[] = []
    ) {
        this.merchantAppId = merchantAppId;
        this.appId = appId;
        this.messageManager = new MessageManager(lang);
        this.externalMenuItems = externalMenuItems;
        this.showAsShakeForNewFeatureTab = true;

        setTimeout(() => {
            this.showAsShakeForNewFeatureTab = false;
        }, 10 * 1000); //10seconds
        
    }

    getShowAsShakeForNewFeatureTab(): boolean {
        return this.showAsShakeForNewFeatureTab;
    }

    getAppId(): string {
        return this.appId;
    }

    getMerchantAppId(): string {
        return this.merchantAppId;
    }

    getMessageProvider(): MessageProvider {
        return this.messageManager;
    }

    setLangauge(lang: string) {
        this.messageManager.setCurrentLang(lang);

        window.dispatchEvent(new CustomEvent("lang-changed", { detail: { lang: lang } }))
    }

    toggleLeavingExtraMarginBottom() {
        this.leavingExtraMarginBottom = !this.leavingExtraMarginBottom;
    }

    isLeavingExtraMarginBottom() {
        return this.leavingExtraMarginBottom;
    }

    setApiAccess(apiAccess: ApiAccess) {
        this.apiAccess = apiAccess;
    }

    getApiAccess(): ApiAccess {
        return this.apiAccess;
    }

    getExternalMenuItems(): AppMenuItemData[] {
        return this.externalMenuItems;
    }
}